export const PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_SORT = 'PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_SORT';

export const PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE =
	'PHONE_CALL_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE';
